import '../tabs.scss';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Well from '../../../components/well';

import Products from './admin-tab/products';
import UserAccess from './admin-tab/user-access';
import UserCache from './admin-tab/user-cache';

class AdminTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            key: 'reports',
        };

        this.onSelect = R.bind(this.onSelect, this);
    }

    onSelect(key) {
        this.setState({ key });
    }

    render() {
        const {
            adminReducer,
            fetchUserCache,
            expireUserCache,
            fetchAccountAccess,
            createAccountAccess,
            setAccountAccess,
            setProductAccess,
            fetchProductList,
        } = this.props;

        return (
            <Well className="admin-tab">
                <Tabs activeKey={this.state.key} onSelect={this.onSelect} id="controlled-admin-tab">
                    {/* <Tab eventKey="reports" title="Reports">
                        <Reports />
                    </Tab> */}
                    <Tab eventKey="cache" title="User Cache">
                        <UserCache
                            adminReducer={adminReducer}
                            fetchUserCache={fetchUserCache}
                            expireUserCache={expireUserCache}
                        />
                    </Tab>
                    <Tab eventKey="access" title="User Access">
                        <UserAccess
                            adminReducer={adminReducer}
                            fetchAccountAccess={fetchAccountAccess}
                            createAccountAccess={createAccountAccess}
                            setAccountAccess={setAccountAccess}
                        />
                    </Tab>
                    <Tab eventKey="products" title="Enable Products">
                        <Products
                            adminReducer={adminReducer}
                            setProductAccess={setProductAccess}
                            fetchProductList={fetchProductList}
                        />
                    </Tab>
                </Tabs>
            </Well>
        );
    }
}

AdminTab.propTypes = {
    adminReducer: PropTypes.object,
    fetchUserCache: PropTypes.func,
    expireUserCache: PropTypes.func,
    fetchAccountAccess: PropTypes.func,
    createAccountAccess: PropTypes.func,
    setAccountAccess: PropTypes.func,
    setProductAccess: PropTypes.func,
    fetchProductList: PropTypes.func,
};

export default AdminTab;
